window.setupFiltersHelper = function () {
  // Filter sticky styling
  const facetsWrapper = document.querySelector('.facets-wrapper');
  if (!facetsWrapper) return;

  const checkIfStuck = () => {
    const isStuck = facetsWrapper.getBoundingClientRect().top <= 0;
    facetsWrapper.classList.toggle('stuck', isStuck);
  };

  window.addEventListener('scroll', checkIfStuck, { passive: true });
  checkIfStuck();

  // Filter drawer z-index
  const mobileFacetsDetails = document.querySelector('.mobile-facets__disclosure');
  if (!mobileFacetsDetails) return;

  const updateZIndex = () => {
    const facetsWrapper = document.querySelector('.facets-wrapper');
    if (!facetsWrapper) return;

    if (mobileFacetsDetails.hasAttribute('open')) {
      facetsWrapper.style.zIndex = '10';
    } else {
      facetsWrapper.style.zIndex = '';
    }
  };

  updateZIndex();
  mobileFacetsDetails.addEventListener('toggle', updateZIndex);

  // Sort dropdown
  const dropdown = document.querySelector('.dropdown-filter');
  if (!dropdown) return;

  const button = dropdown.querySelector('button');
  const options = dropdown.querySelectorAll('.mobile-facets__item input[type="radio"]');

  const closeDropdown = () => {
    dropdown.classList.remove('opened');
    button.setAttribute('aria-expanded', 'false');
  };

  button.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.toggle('opened');
    const isOpened = dropdown.classList.contains('opened');
    button.setAttribute('aria-expanded', isOpened ? 'true' : 'false');
  });

  options.forEach((input) => {
    input.addEventListener('change', (e) => {
      e.stopPropagation();
      options.forEach((i) => i.closest('label').classList.remove('active'));
      input.closest('label').classList.add('active');
      button.textContent = input.closest('label').innerText.trim();
      closeDropdown();
      input.dispatchEvent(new CustomEvent('filter-updated', { bubbles: true }));
    });
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) {
      closeDropdown();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeDropdown();
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(() => {
    setupFiltersHelper();
  });
});

document.addEventListener('shopify:section:load', () => {
  requestAnimationFrame(() => {
    setupFiltersHelper();
  });
});

document.addEventListener('facet-filter-updated', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const values = urlParams.getAll('filter.p.m.custom.super_filter');

  if (values.length === 0) {
    document.querySelectorAll('.super-filter-input').forEach((input) => {
      input.checked = false;
      input.closest('.tag-filter-button').classList.remove('active');
    });
  }
});
